import * as asset from './Endpoints/AssetEndpoint';
import deliveries from './Endpoints/DeliveriesEndpoint';
import deviceReps from './Endpoints/DeviceRepsEndpoint';
import implants from './Endpoints/ImplantsEndpoint';
import nameAliases from './Endpoints/NameAliasEndpoint';
import contact from './Endpoints/ContactEndpoint';
import orders from './Endpoints/OrdersEndpoint';
import surgeries from './Endpoints/SurgeriesEndpoint';
import setsSadl from './Endpoints/SetsSadlEndpoint';
import smartways from './Endpoints/Smartways';
import suppliers from './Endpoints/SuppliersEndpoint';
import surgeons from './Endpoints/SurgeonsEndpoint';
import * as userManagement from './Endpoints/UserManagementEndpoint';
import users from './Endpoints/UsersEndpoint';
import errorHandler from './ErrorHandler';

export type LanguageMetadata = {
  manual_japanese?: string | null;
  manual_english?: string | null;
  description_japanese?: string | null;
  description_english?: string | null;
};

export type TestMetadata = {
  additional_inspection_english?: string | null;
  additional_inspection_japanese?: string | null;
  torque_test?: boolean;
  functional_test?: boolean;
  debris_test?: boolean;
};

const API = {
  asset,
  deliveries,
  implants,
  errorHandler,
  suppliers,
  surgeons,
  deviceReps,
  users,
  setsSadl,
  userManagement,
  orders,
  surgeries,
  nameAliases,
  contact,
  smartways,
};

export default API;
